export const CUSTOMERS_COLLECTION_ENDPOINT = '/customers/';
export const VEHICLES_COLLECTION_ENDPOINT = '/vehicles/';

export const buildCustomerSearchEndpoint = (query: string): string =>
  `${CUSTOMERS_COLLECTION_ENDPOINT}?search=${encodeURIComponent(query)}&search_fields=name,phone&limit=20`;

export const buildVehicleSearchEndpoint = (query: string): string =>
  `${VEHICLES_COLLECTION_ENDPOINT}?search=${encodeURIComponent(query)}&limit=20&status=available`;

export const buildAvailableVehiclesEndpoint = (limit = 100): string =>
  `${VEHICLES_COLLECTION_ENDPOINT}?status=available&limit=${limit}`;
